// @ts-nocheck

import { fetchRequest, initialFetchListParams, downloadRequestWithToken } from './index';
export const addEmployee = async employee => {
  const added = await fetchRequest.post('/employee', employee);
  if (added) return added;
  throw new Error('Не удалось создать сотрудника');
};
export const updateEmployee = async employee => {
  const updated = await fetchRequest.put('/employee', employee);
  if (updated) return updated;
  throw new Error('Не удалось обновить сотрудника');
};
export const fetchEmployee = async (id, params = {}) => {
  let employee = await fetchRequest.get(`/employee/${id}`, params);
  if (employee) return employee;
  throw new Error('Не удалось загрузить сотрудника');
};
export const fetchEmployees = async (params = initialFetchListParams) => await fetchRequest.get('/employee', {
  ...initialFetchListParams,
  ...params
});
export const deleteEmployee = async id => {
  const deleted = await fetchRequest.delete(`/employee/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить сотрудника');
};
export const print = async () => {
  const printed = await downloadRequestWithToken('/employee/print');
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};
export const fetchBranchEmployeesPositions = async branchId => {
  return await fetchRequest.get(`/employee/branchEmployees/${branchId}`, {});
};
export default {
  addEmployee,
  updateEmployee,
  fetchEmployees,
  fetchEmployee,
  deleteEmployee,
  print,
  fetchBranchEmployeesPositions
};
